export default __webpack_public_path__ + "f1b5a58cd3ffa71719a997459f2cc84d.png";